<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xv3prR/tc-custom/9781504041249.jpg?1707822774986" alt="This image is the cover for the book Geronimo's Story of His Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Geronimo's Story of His Life
      </h1>
      <p class="bookDescription body article font2">
        <b>A pivotal piece of nineteenth-century Native American history from a tireless warrior seeking justice for his people. </b><br/><br/> Storied leader of the Bedonkohe band of the Chiricahua Apache tribe, Geronimo led resistance against Mexican and American troops seeking to drive the Apache from their land during the 1850s through the 1880s. In 1886, he finally surrendered to the US Army and became a prisoner of war. Although he would never return to his homeland, Geronimo became an iconic figure in Native American society and even had the honor of riding with President Theodore Roosevelt in his 1905 inaugural parade. That same year, he agreed to share his story with Stephen M. Barrett, a superintendent of education from Lawton, Oklahoma.<br/>  <br/> In Geronimo’s own words, this is his fascinating life story. Beginning with an Apache creation myth, he discusses his youth and family, the bloody conflicts between Mexico and the United States, and his two decades of life as a prisoner. Revered by his people and feared by his enemies, Geronimo narrates his memoir with a compassionate and compelling voice that still resonates today.<br/><br/><br/>  <br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Geronimo, S. M. Barrett
      </h2>
      
      <p class="authorDescription body article">Geronimo (1829&ndash;1909) was a Bedonkohe leader of the Apache Chiracahua tribe. He orchestrated one of the last militarized Native American uprisings against the United States government, defending his tribe&rsquo;s native lands for over twenty-five years. Born in No-Doyohn Canyon, New Mexico, he spearheaded raids in the Southwest until he surrendered to US troops in 1886. He documented his life in <I>Geronimo&rsquo;s Story of His Life </I>in 1905.<BR /><BR /> S. M. Barrett, superintendent of education in Lawton, Oklahoma, was best known for dictating the life of Geronimo.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5812d7e7